const chargesLang = {

}

export default {
  charges: chargesLang
}
